import { createFileRoute } from '@tanstack/react-router'
import DocumentsPage from '../../components/Documents/DocumentsPage'

export const Route = createFileRoute('/_layout/documents')({
  component: DocumentsPage,
})
